/**
 * WLT1 admin-panel key bootstrap — env reads + a memoised keys promise.
 *
 * CRA inlines every `REACT_APP_*` var into the client bundle, so these values
 * are NOT secret from the browser (SECURITY.md §1). They protect against
 * interception / devtools / screenshots / log capture, not against someone
 * reading the bundle. Different value per env, never committed.
 */

import { base64Decode, deriveKeys } from './wlt1'

const {
    REACT_APP_WLT_ENABLED,
    REACT_APP_WLT_KID,
    REACT_APP_WLT_MASTER,
    REACT_APP_WLT_SALT,
    REACT_APP_WLT_DEV_BYPASS,
} = process.env

export const wltEnabled = REACT_APP_WLT_ENABLED === 'true'
export const wltKid = REACT_APP_WLT_KID || 'web-v1'
export const wltDevBypass = REACT_APP_WLT_DEV_BYPASS === 'true'

let keysPromise = null

/**
 * Derive the request/response AES-GCM keys once and cache the promise.
 *
 * Callers can `await getKeys()` on every request without re-doing HKDF — the
 * promise is memoised. Fails loudly if the flag is on but any key var is
 * missing, so a broken build doesn't silently ship plaintext.
 */
export function getKeys() {
    if (keysPromise) return keysPromise

    if (!wltEnabled) {
        keysPromise = Promise.reject(
            new Error('WLT1 disabled — REACT_APP_WLT_ENABLED is not "true"'),
        )
        return keysPromise
    }

    if (!REACT_APP_WLT_MASTER || !REACT_APP_WLT_SALT) {
        keysPromise = Promise.reject(
            new Error(
                'WLT1 enabled but REACT_APP_WLT_MASTER / REACT_APP_WLT_SALT are missing. ' +
                    'Inject both (b64 32B / b64 16B) at build time.',
            ),
        )
        return keysPromise
    }

    try {
        const master = base64Decode(REACT_APP_WLT_MASTER)
        const salt = base64Decode(REACT_APP_WLT_SALT)
        keysPromise = deriveKeys(wltKid, master, salt)
    } catch (err) {
        keysPromise = Promise.reject(err)
    }
    return keysPromise
}
